
import BaseAnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class AnticipateAnimateOverSymbolBehaviour extends BaseAnimateSymbolBehaviour {

    public behaviourName: string = "AnticipateAnimateOver";

    /**
     * Same as AnimateBehaviour except for landing
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win") {
        super(symbol, defaultAnimation);
    }

    public anticipate(): Contract<void> {
        return this.animate("_antic_over", ["antic_over"], false, true);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
